// extracted by mini-css-extract-plugin
export default {"Container":"Cards_Container__lCg4Y","Cards-wrapper":"Cards_Cards-wrapper__yR-0o","card":"Cards_card__2l2WX","icon-wrapper":"Cards_icon-wrapper__gQlJn"};